import { Component } from '@angular/core';
import { InputConfig } from '@vuframe/vf-webviewer/lib/interfaces/interfaces';

import { environment } from '../../../environments/environment';

/**
 * This component wraps the vf-share-code-form from the @vuframe/vf-webviewer package.
 * This wrapper is used, so we can route to the component.
 */
@Component({
    selector: 'vf-share-form-wrapper',
    template: '<vf-share-code-form [inputConfig]="inputConfig"></vf-share-code-form>',
})
export class ShareCodeFormWrapperComponent {
    inputConfig: InputConfig = {
        ...environment,
        API_TOKEN: atob(environment.API_TOKEN),
        API_SECRET: atob(environment.API_SECRET),
        KEEN_PROJECT_ID: atob(environment.KEEN_PROJECT_ID),
        KEEN_WRITE_KEY: atob(environment.KEEN_WRITE_KEY),
        VIEWER_BASE_URL: environment.SHARE_V2_URL + "/"
    };
}
